import { useCallback, useState } from 'react';

export function useConfirmDialog({ onConfirm, onAfterConfirm } = {}) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dialogData, setDialogData] = useState({
        title: '',
        content: '',
        payload: null,
        confirmLabel: 'Confirmar',
        confirmColor: 'primary',
        disableConfirm: false,
    });

    const openDialog = useCallback((config = {}) => {
        setDialogData({
            title: config.title || '',
            content: config.content || '',
            payload: config.payload ?? null,
            confirmLabel: config.confirmLabel || 'Confirmar',
            confirmColor: config.confirmColor || 'primary',
            disableConfirm: !!config.disableConfirm,
        });
        setOpen(true);
    }, []);

    const closeDialog = useCallback(() => {
        if (loading) return;
        setOpen(false);
        setDialogData({
            title: '',
            content: '',
            payload: null,
            confirmLabel: 'Confirmar',
            confirmColor: 'primary',
            disableConfirm: false,
        });
    }, [loading]);

    const confirmDialog = useCallback(async () => {
        if (!onConfirm) {
            closeDialog();
            return;
        }

        try {
            setLoading(true);
            await onConfirm(dialogData);
            if (onAfterConfirm) {
                await onAfterConfirm(dialogData);
            }
            closeDialog();
        } finally {
            setLoading(false);
        }
    }, [onConfirm, onAfterConfirm, dialogData, closeDialog]);

    return {
        state: {
            open,
            loading,
            dialogData,
        },
        actions: {
            openDialog,
            closeDialog,
            confirmDialog,
        },
    };
}
